import { render, staticRenderFns } from "./DashKpiStrip.vue?vue&type=template&id=129afbbb&"
import script from "./DashKpiStrip.vue?vue&type=script&lang=js&"
export * from "./DashKpiStrip.vue?vue&type=script&lang=js&"
import style0 from "./DashKpiStrip.vue?vue&type=style&index=0&id=129afbbb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports